module.exports = __webpack_public_path__ + "img/tutorial02.e8aba8b5.png";